import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import userReducer, { UserSliceType } from './Users/slice';
import global from './Global/slice';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

export interface RootState {
  user: UserSliceType;
  global: any;
}

const store = configureStore({
  reducer: {
    user: userReducer,
    global
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);

export default store;
